import { render, staticRenderFns } from "./UploadTransactions.vue?vue&type=template&id=16d95816"
import script from "./UploadTransactions.vue?vue&type=script&lang=js"
export * from "./UploadTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d95816')) {
      api.createRecord('16d95816', component.options)
    } else {
      api.reload('16d95816', component.options)
    }
    module.hot.accept("./UploadTransactions.vue?vue&type=template&id=16d95816", function () {
      api.rerender('16d95816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/treasury_accounts/UploadTransactions.vue"
export default component.exports